'use client';
import { ClientSiteContentRenderer } from '@components/ClientSiteContentRenderer';
import { Timer } from '@components/Timer';
import { UiKitButton } from '@components/UiKitButton';
import styles from '@features/AuthScreenSwitcher/ScreenSwitcher.module.css';
import { observer } from '@legendapp/state/react';
import { useMemo, useState } from 'react';
import { useRootStore } from 'src/providers';

export const ResendScreen = observer(
  ({ goNext, goPrevious }: { goNext: () => void; goPrevious: () => void }) => {
    const store$ = useRootStore();
    const [timerCompleted, setTimerCompleted] = useState(false);

    const userDataFromStorage = useMemo(() => {
      const dataFromStore = store$.recoveryData.get();
      const userData = Array.isArray(dataFromStore) ? dataFromStore : [];

      return userData.length > 0 ? userData[userData.length - 1] : null;
    }, [store$.recoveryData.get()]);

    const targetTime = useMemo(
      () => userDataFromStorage?.targetTime ?? 0,
      [userDataFromStorage?.targetTime],
    );

    return (
      <>
        <h2 className={styles.title}>
          <ClientSiteContentRenderer path="pages.auth.check_email.header" />
        </h2>
        <p className={styles.description}>
          <ClientSiteContentRenderer path="pages.auth.check_email.description" />
          <strong> {userDataFromStorage?.email}</strong>
        </p>

        <div className={styles.buttonContainer}>
          <UiKitButton
            color="secondary"
            fullWidth
            onClick={goPrevious}
            disabled={!timerCompleted}
            className={styles.resendButton}
          >
            <span>Resend</span>
            {targetTime > 0 && !timerCompleted && (
              <>
                In{' '}
                <Timer
                  targetTimeInMs={targetTime}
                  onCountdownComplete={() => setTimerCompleted(true)}
                />
              </>
            )}
          </UiKitButton>

          <UiKitButton fullWidth onClick={goNext} color="primary">
            <ClientSiteContentRenderer path="pages.auth.check_email.login_button" />
          </UiKitButton>
        </div>
      </>
    );
  },
);
